import { FC } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const TheComp: FC = () => {
    const { useLang, useEffect, useState, useRouter } = useGlobal();
    const { t } = useLang('dp3.teaser.HearStories');
    const { locale } = useRouter();
    const [gap, setGap] = useState(16);
    const cards = [
        {
            link: 'https://www.facebook.com/ken.smith.35977',
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717761564307/aa1.jpg',
            name: 'Ken S., Gainesville, TX',
            user_icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717223834507/kol_1_avatar.png',
            desc: 'Love the beautiful and sleek new design. It powered my whole home and 3.5 ton HVAC with this little beast.',
        },
        {
            link: 'https://www.facebook.com/luke.lin.5011',
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717761564481/aa2.jpg',
            name: 'Luke L., Monticello, IL',
            user_icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717223834852/kol_2_avatar.png',
            desc: 'DELTA Pro 3 can run a well pump in an emergency. I am ecstatic that my pressure washer works with the DP3. I absolutely adore the amazing design and game-changing quiet fans.',
        },
        {
            link: 'https://www.facebook.com/mtrdreams',
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717761564669/aa3.jpg',
            name: 'Mike T., Alhambra, CA ',
            user_icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717223835202/kol_3_avatar.png',
            desc: 'The extra battery is half the size of the main unit and stacks on top. DP3 powered my washer and dryer, fridge, and lights with no problems, and yet it is still portable enough to put in my SUV and charge it at an EV charger during emergencies. ',
        },
        {
            link: ' https://www.facebook.com/metaphorse',
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717761564852/aa4.jpg',
            name: 'Andrew C., Upland, CA',
            user_icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717223835550/kol_4_avatar.png',
            desc: 'Thanks to the Delta Pro 3 I can continue working from home uninterrupted. ... reliable power means being entertained through prolonged power outages.',
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const winW = window?.innerWidth;
            setGap(winW > 1440 ? 24 : 16);
        }
    }, []);

    return (
        <div id="dp3-teaser-J" className={`${css.thecomp} dp3-module-box dp3-teaser-J`}>
            <h2 className="dp3-title left">{t('title')}</h2>
            <Swiper className={`swiper-box`} modules={[Navigation]} navigation={true} spaceBetween={gap} slidesPerView={'auto'} initialSlide={0}>
                {cards?.map((card: any, k: number) => {
                    return (
                        <SwiperSlide className={`swiper-item`} key={k}>
                            <div className="card-img">
                                <EFPicture src={card.pc} alt={card?.desc} />
                            </div>
                            <div className="card-info">
                                <svg className="card-quote" xmlns="http://www.w3.org/2000/svg" width="17" height="14" viewBox="0 0 17 14" fill="none">
                                    <g clipPath="url(#clip0_1209_30630)">
                                        <path
                                            d="M3.05176e-05 9.24596C3.05176e-05 5.20712 1.74253 1.67314 6.63003 1V3.4822C4.03753 4.3657 3.61253 5.41748 3.48503 8.02589H6.63003V14H3.05176e-05V9.24596ZM10.37 9.24596C10.37 5.20712 12.1125 1.67314 17 1V3.4822C14.4075 4.3657 13.9825 5.41748 13.855 8.02589H17V14H10.37V9.24596Z"
                                            fill="black"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1209_30630">
                                            <rect width="17" height="14" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                <p className="card-text">{card?.desc}</p>
                            </div>
                            <div className="card-user">
                                <div className="user-img">
                                    <EFPicture src={card?.user_icon} alt={card?.name} />
                                </div>
                                <span className="user-name">{card?.name}</span>
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
            {locale === 'au' && <p className="tip">Note: The product shown is the US version; the Australian version may differ based on the final product.</p>}
        </div>
    );
};

export default TheComp;
